import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, computed, effect, inject, PLATFORM_ID, signal } from "@angular/core";
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { SalesService } from "../../services/sales-agent.service";
import { AuthService } from "../../../../core/services/auth.service";
import { SalesForm } from "../../models/sales-agent.model";
import { LoaderComponent } from "../../../../shared/general/components/loader/loader.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Router } from "@angular/router";

@Component({
  selector: 'app-agent-w9-record',
  imports: [
    CommonModule,
    MatCardModule,
    MatCardContent,
    MatIconModule,
    MatButtonModule,
    LoaderComponent
  ],
  templateUrl: './agent-w9-records.html',
  styleUrl: './agent-w9-records.scss',
})
export class AgentW9RecordComponent {
  private salesService = inject(SalesService);
  private auth = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);

  forms = signal<SalesForm[]>([]);
  isLoading = signal(true);                    // ← ADD THIS

  // Computed signals remain the same
  termsForm = computed(() => {
    const id = this.auth.userId();
    return this.forms().find(f => f.formType === 'sales' && f.userId === id);
  });

  referralForms = computed(() => {
    const id = this.auth.userId();
    return this.forms().filter(f => f.formType === 'sales' && f.userId !== id);
  });

  listingForms = computed(() => {
    return this.forms().filter(f => f.formType === 'listing');
  });

  w9Form = computed(() => {
    const id = this.auth.userId();
    return this.forms().find(f => f.formType === 'w9' && f.userId === id);
  });

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        const id = this.auth.userId();

        if (id) {
          this.isLoading.set(true);                    // Start loading

          this.salesService.getSalesAgentW9FormsByUserId(id).subscribe({
            next: (data) => {
              this.forms.set(data ?? []);              // Safe fallback
              this.isLoading.set(false);               // Stop loading
            },
            error: (err) => {
              console.error('Failed to load forms', err);
              this.forms.set([]);
              this.isLoading.set(false);               // Always stop loading on error
            }
          });
        } else {
          this.forms.set([]);
          this.isLoading.set(false);
        }
      });
    }
  }

  goToW9() {
    this.router.navigate(['common-forms'], { queryParams: { form: 'w9' } });
  }
}